import { EventEmitter } from "events";

export const emitter = new EventEmitter();

export enum EEvents {
  LOGOUT = "LOGOUT",
}
